// lib/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAFi-f2vtcvwuhnZZu9W7pkwV6aAPxe1wM",
  authDomain: "tqneen-com.firebaseapp.com",
  projectId: "tqneen-com",
  storageBucket: "tqneen-com.firebasestorage.app",
  messagingSenderId: "650993756786",
  appId: "1:650993756786:web:7ea649822d2c32e5d6f0eb"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app;